import app from 'flarum/app';
import Component from 'flarum/Component';
import Button from 'flarum/components/Button';
import humanTime from 'flarum/helpers/humanTime';
import icon from 'flarum/helpers/icon';

/* global m */

const translationPrefix = 'kilowhat-formulaire.forum.save-controls.';

export default class SaveControls extends Component {
    init() {
        super.init();

        this.previouslyPromptedForUser = false;
        this.inCooldownPeriod = false;
    }

    view() {
        const {
            dirty,
            loading,
            savedAt,
            inError,
            onsave, // Callback
            history, // providing a ValueHistory object shows the undo/redo controls
            floating, // Whether to enable the floating behavior
        } = this.props;

        // Prompt for user means whether the controls should be made clearly visible to the user
        // if floating behavior is enabled, the controls will float when this value is true
        let promptForUser = dirty;

        if (history) {
            promptForUser = promptForUser || history.canUndo() || history.canRedo();
        }

        // We don't want to hide the controls immediately after a save
        // if the value just changed back to false, we apply a cooldown period during which it will continue to be active
        if (this.previouslyPromptedForUser === true && promptForUser === false) {
            this.inCooldownPeriod = true;

            setTimeout(() => {
                this.inCooldownPeriod = false;
                m.redraw();
            }, 1000);
        }
        this.previouslyPromptedForUser = promptForUser;
        promptForUser = promptForUser || this.inCooldownPeriod;

        let message = null;

        if (inError) {
            message = m('span.in-error', [
                icon('fas fa-exclamation-triangle'),
                ' ',
                app.translator.trans(translationPrefix + 'validation-errors'),
            ]);
        } else if (dirty) {
            message = app.translator.trans(translationPrefix + 'unsaved-changes');
        } else if (savedAt) {
            message = m('span.success', [
                icon('fas fa-check'),
                ' ',
                app.translator.trans(translationPrefix + 'saved-at', {
                    ago: humanTime(savedAt),
                }),
            ]);
        }

        return m('.FormulaireSaveWrapper', m('.FormulaireSave', {
            className: floating && promptForUser ? 'floating' : '',
        }, [
            m('.FormulaireSave-stretch', message),
            history ? [
                Button.component({
                    onclick: () => {
                        history.undo();
                    },
                    disabled: !history.canUndo() || loading,
                    className: 'Button',
                    icon: 'fas fa-undo',
                }, app.translator.trans(translationPrefix + 'undo')),
                Button.component({
                    onclick: () => {
                        history.redo();
                    },
                    disabled: !history.canRedo() || loading,
                    className: 'Button',
                    icon: 'fas fa-redo',
                }, app.translator.trans(translationPrefix + 'redo')),
            ] : null,
            Button.component({
                onclick: onsave,
                disabled: !dirty || loading,
                className: 'Button Button--primary FormulairePrimaryButton',
                icon: 'fas fa-save',
                loading,
            }, app.translator.trans(translationPrefix + 'save')),
        ]));
    }

    config(isIntialized, context) {
        if (isIntialized) {
            return;
        }

        const updateOverlayWidth = () => {
            const overlay = this.element.querySelector('.FormulaireSave');
            const rect = this.element.getBoundingClientRect();

            if (overlay && rect.width > 0) {
                overlay.style.width = rect.width + 'px';
            }
        };

        updateOverlayWidth();

        window.addEventListener('resize', updateOverlayWidth);

        context.onunload = () => {
            window.removeEventListener('resize', updateOverlayWidth);
        };
    }
}
